export function strictifyHttpVerb(notStrict) {
  return `${notStrict}`.toUpperCase();
}